package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
enum class ModerationStatus {
    DRAFT,
    PENDING_MODERATION,
    APPROVED,
    FLAGGED_BY_AI,
    MANUAL_REVIEW_NEEDED
}